import styled from 'styled-components';

export const Container = styled.div`
  .mode-container {
    width: 936px;
    margin: 0 auto;
    .back-icon {
      transform: rotate(180deg);
      position: relative;
      top: -1px;
      left: -3px;
    }
    .summary {
      padding: 18px 16px;
    }
    .mode-container {
      border-top: 1px solid #fafafa;
      .card-info {
        align-items: flex-end;
      }
      .card-num {
        line-height: 40px;
      }
      .form-btn {
        padding: 9px 36px;
      }
      .info-column {
        margin-right: 16px;
      }
      .card-number {
        flex-basis: 35%;
      }
      .name {
        flex-basis: 30%;
      }
      .error-field {
        .form-input {
          border-color: red;
          &:focus {
            border-color: red;
            outline: none;
          }
        }
      }
    }
    .accordian-title {
      font-weight: 600;
    }
  }
`;
